<template>
  <q-img
    v-if="imgSrc && !imgError"
    :src="imgSrc"
    :alt="alt"
    style="max-width: 300px"
    :class="{ 'cursor-pointer': editable }"
    @click="handleClick"
    @error="handleError"
  >
    <q-icon
      v-if="editable"
      color="primary"
      name="edit"
      size="xs"
      class="absolute-top-right q-ma-sm"
    >
    </q-icon>
    <q-tooltip v-if="editable" anchor="center middle">Edit Property Thumbnail</q-tooltip>
    <q-tooltip v-else anchor="center middle">
      Your Organization has disabled editing thumbnails.
    </q-tooltip>
  </q-img>
  <div
    v-else
    class="bg-grey-3 relative-position"
    :class="{ 'bg-grey-9': $q.dark.isActive, 'cursor-pointer': editable }"
    style="max-width: 300px; width: 100%; height: 150px"
    @click="handleClick"
  >
    <q-icon name="apartment" class="absolute-center text-grey-5" size="lg" />
    <q-icon
      v-if="editable"
      color="primary"
      name="edit"
      size="xs"
      class="absolute-top-right q-ma-sm"
    >
    </q-icon>
    <q-tooltip v-if="editable" anchor="center middle">Edit Property Thumbnail</q-tooltip>
    <q-tooltip v-else anchor="center middle">
      Your Organization has disabled editing thumbnails.
    </q-tooltip>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'

export default {
  name: 'PropertyImage',
  props: {
    imgSrc: {
      type: String as PropType<string | null>,
      required: true
    },
    alt: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['click'],
  data() {
    return {
      imgError: false
    }
  },
  watch: {
    imgSrc() {
      this.imgError = false
    }
  },
  methods: {
    handleClick() {
      if (this.editable) {
        this.$emit('click')
      }
    },
    handleError() {
      this.imgError = true
    }
  }
}
</script>
